import { enumsRolesPermissions, enumsTypeUser } from "utils/enums";

export const canAccessMetrics = ({ isLogged, userType, rolesPermissionsGranted }) => {
  const isAdmin = isLogged === true && userType === enumsTypeUser.ADMIN;
  const isStandard = isLogged === true && userType === enumsTypeUser.STANDARD;

  return (
    isAdmin ||
    (isStandard &&
      Array.isArray(rolesPermissionsGranted) &&
      rolesPermissionsGranted.includes(enumsRolesPermissions.METRICS))
  );
};
